<script>
import { mapGetters } from "vuex";
import SettingsSection from "dashboard/components/SettingsSection.vue";
import LoadingState from "dashboard/components/widgets/LoadingState.vue";
import NextButton from "dashboard/components-next/button/Button.vue";
import ToggleSwitch from "dashboard/components-next/switch/Switch.vue";

import QrCodeApi from "dashboard/api/qrCode";

export default {
  components: {
    SettingsSection,
    LoadingState,
    NextButton,
    ToggleSwitch
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      CHATWOOT_URL: window.location.origin,
      evoInstanceName: '',
      connected: false,
      serverStatus: true,
      img: false,
      section1_message: "via QR Code.",
      loading: false,
      sec: 0,

      settings_reject_call: false,
      settings_msg_call: "",
      settings_groups_ignore: true,
      settings_always_online: false,
      settings_read_messages: false,
      settings_read_status: false,
      settings_sync_full_history: true,

      chatwoot_sign_msg: false,
      chatwoot_reopen_conversation: false,
      chatwoot_conversation_pending: false,
      chatwoot_import_contacts: false,
      chatwoot_import_messages: false,
      chatwoot_merge_brazil_contacts: false,
      chatwoot_days_limit_import_messages: 30,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  async mounted() {
    this.evoInstanceName = this.extractInstanceName(this.inbox.webhook_url);

    await this.instanceConnectionState();
  },
  methods: {
    extractInstanceName(webhookURL) {
      if (typeof webhookURL === 'string') {
        const match = webhookURL.match(/\/chatwoot\/webhook\/([^/?#]+)/);
        if (match && match[1]) {
          return decodeURIComponent(match[1]);
        }
      }

      return `${this.accountId}_${this.inbox?.id}_${this.inbox?.inbox_identifier}`;
    },
    async toggleSwitch(name) {
      // o v-model do ToggleSwitch já atualizou o valor local, aqui só persistimos
      if (name.startsWith('chatwoot_')) {
        await this.chatwootSet();
        return;
      }

      await this.settingsSet();
    },
    async updateMsgCall(event) {
      this.settings_msg_call = event.target.value;
      await this.settingsSet();
    },
    async instanceConnectionState() {
      // instance connection state
      this.loading = true;

      try {
        // verifica se existe uma instância conectada na API (evo2)
        const response = await QrCodeApi.getInstanceConnectionState(
          this.evoInstanceName
        );

        this.loading = false;

        if (response.data.instance.state === 'open') {
          this.connected = true;
          this.section1_message = '✅ Online';
          await this.settingsFind();
          return true;
        }

        await this.settingsFind();
        return false;
      } catch (error) {
        console.error(error);
        if (error.response?.status === 404) {
          await this.createInstance();
        }
      } finally {
        this.loading = false;
      }
    },
    async settingsFind() {
      this.loading = true;
      try {
        const evo_settings = await QrCodeApi.getSettings(this.evoInstanceName);
        const evo_chatwoot = await QrCodeApi.getChatwoot(this.evoInstanceName);

        // settings
        this.settings_reject_call = evo_settings.data.rejectCall;
        this.settings_msg_call = evo_settings.data.msgCall;
        this.settings_groups_ignore = evo_settings.data.groupsIgnore;
        this.settings_always_online = evo_settings.data.alwaysOnline;
        this.settings_read_messages = evo_settings.data.readMessages;
        this.settings_read_status = evo_settings.data.readStatus;
        this.settings_sync_full_history = evo_settings.data.syncFullHistory;

        if (evo_chatwoot.data.enabled === true) {
          // chatwoot
          this.chatwoot_sign_msg = evo_chatwoot.data.signMsg;
          this.chatwoot_reopen_conversation =
            evo_chatwoot.data.reopenConversation;
          this.chatwoot_conversation_pending =
            evo_chatwoot.data.conversationPending;
          this.chatwoot_import_contacts = evo_chatwoot.data.importContacts;
          this.chatwoot_import_messages = evo_chatwoot.data.importMessages;
          this.chatwoot_merge_brazil_contacts =
            evo_chatwoot.data.mergeBrazilContacts;
          this.chatwoot_days_limit_import_messages =
            evo_chatwoot.data.daysLimitImportMessages;
          await this.setChatwootWebhook(evo_chatwoot.data.webhook_url);
        } else {
          await this.chatwootSet();
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async createInstance() {
      // create instance
      this.loading = true;

      let payload = {
        instanceName: this.evoInstanceName,
        token: this.inbox.inbox_identifier,
        qrcode: false,
        integration: 'WHATSAPP-BAILEYS',

        rejectCall: this.settings_reject_call,
        msgCall: this.settings_msg_call,
        groupsIgnore: this.settings_groups_ignore,
        alwaysOnline: this.settings_always_online,
        readMessages: this.settings_read_messages,
        readStatus: this.settings_read_status,
        syncFullHistory: this.settings_sync_full_history,

        chatwootAccountId: String(this.accountId),
        chatwootToken: this.currentUser.access_token,
        chatwootUrl: this.CHATWOOT_URL,
        chatwootSignMsg: this.chatwoot_sign_msg,
        chatwootReopenConversation: this.chatwoot_reopen_conversation,
        chatwootConversationPending: this.chatwoot_conversation_pending,
        chatwootImportContacts: this.chatwoot_import_contacts,
        chatwootNameInbox: this.inbox.name,
        chatwootMergeBrazilContacts: this.chatwoot_merge_brazil_contacts,
        chatwootImportMessages: this.chatwoot_import_messages,
        chatwootDaysLimitImportMessages:
        this.chatwoot_days_limit_import_messages,
        chatwootOrganization: this.globalConfig.installationName,
        chatwootLogo: `${this.CHATWOOT_URL}/brand-assets/logo_thumbnail.svg`,
      };

      try {
        const response = await QrCodeApi.instanceCreate(payload);
        await this.instanceConnectionState();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async instanceConnect() {
      // instance connect
      this.loading = true;
      try {
        const response = await QrCodeApi.instanceConnect(this.evoInstanceName);
        this.img = response.data.base64;
        this.countdown();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async instanceDisconnect() {
      // disconnect instance
      this.loading = true;

      const response = await QrCodeApi.instanceLogout(this.evoInstanceName);
      await this.instanceConnectionState();
      this.loading = false;
    },
    async chatwootSet() {
      // chatwoot set
      let payload = {
        enabled: true,
        accountId: String(this.accountId),
        token: this.currentUser.access_token,
        url: this.CHATWOOT_URL,
        signMsg: this.chatwoot_sign_msg,
        reopenConversation: this.chatwoot_reopen_conversation,
        conversationPending: this.chatwoot_conversation_pending,
        nameInbox: this.inbox.name,
        mergeBrazilContacts: this.chatwoot_merge_brazil_contacts,
        importContacts: this.chatwoot_import_contacts,
        importMessages: this.chatwoot_import_messages,
        daysLimitImportMessages: this.chatwoot_days_limit_import_messages,
        signDelimiter: '\n',
        autoCreate: false,
        organization: this.globalConfig.installationName,
      };

      try {
        const response = await QrCodeApi.setChatwoot(
          this.evoInstanceName,
          payload
        );

        await this.setChatwootWebhook(response.data.webhook_url);
      } catch (error) {
        console.error(error);
      }
    },
    async settingsSet() {
      // settings set on instance
      let payload = {
        rejectCall: this.settings_reject_call,
        msgCall: this.settings_msg_call,
        groupsIgnore: this.settings_groups_ignore,
        alwaysOnline: this.settings_always_online,
        readMessages: this.settings_read_messages,
        syncFullHistory: this.settings_sync_full_history,
        readStatus: this.settings_read_status,
      };

      await QrCodeApi.setSettings(this.evoInstanceName, payload);
    },
    async setChatwootWebhook(webhook_url) {
      if (webhook_url === this.inbox.webhook_url) return;

      await this.$store.dispatch('inboxes/updateInbox', {
        id: this.inbox.id,
        // lock_to_single_conversation: this.$refs.conversaUnica.checked,
        channel: {
          webhook_url: webhook_url,
        },
      });
      this.$emit('update-webhook', webhook_url);
    },
    countdown() {
      this.sec = 20;
      this.section1_message = 'Escaneie o QR Code com seu WhatsApp.';
      this.interval = setInterval(() => {
        this.sec--;

        if (this.sec < 0) {
          clearInterval(this.interval);
          if (
            this.instanceConnectionState() === true &&
            this.connected === true
          ) {
            useAlert('Conectado!');
          } else {
            useAlert('QRCode expirado');
          }
          this.section1_message = 'Conecte seu Whatsapp via QR Code.';
          this.img = false;
        }
      }, 1000);
    }
  }
};
</script>

<template>
  <div class="mx-6 max-w-4xl">
    <LoadingState v-if="loading" />

    <SettingsSection
      v-if="!loading"
      :title="$t('Opções')"
      :sub-title="$t('Configurações.')"
      show-border
    >
      <div class="flex items-center mb-4">
        <ToggleSwitch
          v-model="settings_reject_call"
          @change="toggleSwitch('settings_reject_call')"
        />
        <label class="ml-2" for="settings_reject_call">Rejeitar Chamadas</label>
      </div>
      <div class="flex items-center mb-4">
        <input
          id="settings_msg_call"
          :placeholder="$t('Eu não aceito ligações')"
          :value="settings_msg_call"
          class="mb-0"
          type="text"
          @blur="updateMsgCall"
        />
      </div>

      <div class="flex items-center">
        <ToggleSwitch
          v-model="settings_groups_ignore"
          @change="toggleSwitch('settings_groups_ignore')"
        />
        <label class="ml-2" for="settings_groups_ignore">Ignorar Grupos</label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="settings_always_online"
          @change="toggleSwitch('settings_always_online')"
        />
        <label class="ml-2" for="settings_always_online">Sempre Online</label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="settings_read_messages"
          @change="toggleSwitch('settings_read_messages')"
        />
        <label class="ml-2" for="settings_read_messages">
          Marcar mensagens como lidas
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="settings_read_status"
          @change="toggleSwitch('settings_read_status')"
        />
        <label class="ml-2" for="settings_read_status">
          Marcar status como visto
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="settings_sync_full_history"
          @change="toggleSwitch('settings_sync_full_history')"
        />
        <label class="ml-2" for="settings_sync_full_history">
          Sincronizar historico completo
        </label>
      </div>

      <br />

      <div class="flex items-center">
        <ToggleSwitch
          v-model="chatwoot_sign_msg"
          @change="toggleSwitch('chatwoot_sign_msg')"
        />
        <label
          class="ml-2"
          for="chatwoot_sign_msg"
          title="Assinar Mensagens com nome do agente"
        >
          Assinar Mensagens
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="chatwoot_reopen_conversation"
          @change="toggleSwitch('chatwoot_reopen_conversation')"
        />
        <label class="ml-2" for="chatwoot_reopen_conversation">
          Reabrir Conversas
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="chatwoot_conversation_pending"
          @change="toggleSwitch('chatwoot_conversation_pending')"
        />
        <label class="ml-2" for="chatwoot_conversation_pending">
          Iniciar Conversa como pendente
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="chatwoot_import_contacts"
          @change="toggleSwitch('chatwoot_import_contacts')"
        />
        <label
          class="ml-2"
          for="chatwoot_import_contacts"
          title="Importar Contatos da Agenda"
        >
          Importar Contatos
        </label>
      </div>
      <div class="flex items-center">
        <ToggleSwitch
          v-model="chatwoot_import_messages"
          @change="toggleSwitch('chatwoot_import_messages')"
        />
        <label class="ml-2" for="chatwoot_import_messages">
          Importar Mensagens
        </label>
      </div>
    </SettingsSection>

    <SettingsSection :title="$t('Conectar')" :sub-title="section1_message">
      <NextButton
        v-if="serverStatus && !img && !loading"
        :disabled="connected"
        :label="$t('QR CODE')"
        icon="i-lucide-scan-qr-code"
        @click="instanceConnect"
      />

      <NextButton
        v-if="serverStatus && !img && !loading"
        class="ml-2"
        :label="$t('DESCONECTAR')"
        icon="i-lucide-unplug"
        :disabled="!connected"
        variant="faded"
        color="ruby"
        @click="instanceDisconnect"
      />

      <img
        v-if="img !== false"
        :src="img"
        class="mr-5 rounded-md"
        alt="QRCode"
      />
      <p v-if="img !== false">Tempo restante: {{ sec }} segundos</p>

      <div v-if="loading" class="loading-container">
        <div class="spinner-qrcode" />
        <p>Aguarde...</p>
      </div>
    </SettingsSection>
  </div>
</template>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /*height: 100vh;*/
}

.spinner-qrcode {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #3280c9;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin-qrcode 1s linear infinite;
}

@keyframes spin-qrcode {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
